import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  color?: string;
}

export const AppStoreIcon: React.FC<IconProps> = ({ size = 14, className = '', color = 'currentColor' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 22.773 22.773" 
    className={className}
    fill={color}
  >
    <g>
      <path d="M15.769,0c0.053,0,0.106,0,0.162,0c0.13,1.606-0.483,2.806-1.228,3.675c-0.731,0.863-1.732,1.7-3.351,1.573
        c-0.108-1.583,0.506-2.694,1.25-3.561C13.292,0.879,14.557,0.16,15.769,0z" />
      <path d="M20.67,16.716c0,0.016,0,0.03,0,0.045c-0.455,1.378-1.104,2.559-1.896,3.655c-0.723,0.995-1.609,2.334-3.191,2.334
        c-1.367,0-2.275-0.879-3.676-0.903c-1.482-0.024-2.297,0.735-3.652,0.926c-0.155,0-0.31,0-0.462,0
        c-0.995-0.144-1.798-0.932-2.383-1.642c-1.725-2.098-3.058-4.808-3.306-8.276c0-0.34,0-0.679,0-1.019
        c0.105-2.482,1.311-4.5,2.914-5.478c0.846-0.52,2.009-0.963,3.304-0.765c0.555,0.086,1.122,0.276,1.619,0.464
        c0.471,0.181,1.06,0.502,1.618,0.485c0.378-0.011,0.754-0.208,1.135-0.347c1.116-0.403,2.21-0.865,3.652-0.648
        c1.733,0.262,2.963,1.032,3.723,2.22c-1.466,0.933-2.625,2.339-2.427,4.74C17.818,14.688,19.086,15.964,20.67,16.716z" />
    </g>
  </svg>
);

export const GooglePlayIcon: React.FC<IconProps> = ({ size = 14, className = '', color = 'currentColor' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 32 32" 
    className={className}
    fill={color}
  >
    <path d="m16 0c-8.837 0-16 7.164-16 16s7.163 16 16 16c8.836 0 16-7.164 16-16s-7.163-16-16-16zm.173 24.596c-4.749 0-8.596-3.847-8.596-8.596s3.847-8.596 8.596-8.596c2.321 0 4.261.855 5.748 2.24l-2.423 2.423v-.005c-.902-.86-2.047-1.3-3.325-1.3-2.836 0-5.141 2.396-5.141 5.232s2.305 5.238 5.141 5.238c2.573 0 4.325-1.472 4.685-3.492h-4.685v-3.353h8.085c.107.574.166 1.177.166 1.805 0 4.912-3.288 8.404-8.251 8.404z" />
  </svg>
);

export const Info: React.FC<IconProps> = ({ size = 14, className = '', color = 'currentColor' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

export const InfoIcon: React.FC<IconProps> = ({ size = 14, className = '', color = 'currentColor' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
  >
    <path 
      clipRule="evenodd" 
      fillRule="evenodd" 
      d="M14.0247 4.53728c0-.57287.4644-1.03728 1.0373-1.03728h4.4007c.5729 0 1.0373.46441 1.0373 1.03728v4.4008c0 .57287-.4644 1.03728-1.0373 1.03728-.5728 0-1.0372-.46441-1.0372-1.03728v-1.89681l-5.5641 5.56413c-.405.4051-1.0618.4051-1.4669 0s-.4051-1.0619 0-1.4669l5.5638-5.56394h-1.8963c-.5729 0-1.0373-.46441-1.0373-1.03728zm-7.41291-.1151c-1.71859 0-3.11179 1.39322-3.11179 3.11184v9.85418c0 1.7186 1.3932 3.1118 3.11179 3.1118h9.85401c1.7186 0 3.1118-1.3932 3.1118-3.1118v-4.1492c0-.5728-.4644-1.0372-1.0373-1.0372-.5728 0-1.0372.4644-1.0372 1.0372v4.1492c0 .5728-.4644 1.0372-1.0373 1.0372h-9.85401c-.57286 0-1.03726-.4644-1.03726-1.0372v-9.85418c0-.57288.4644-1.03728 1.03726-1.03728h4.14901c.5729 0 1.0373-.46441 1.0373-1.03728s-.4644-1.03728-1.0373-1.03728z" 
    />
  </svg>
);


export const ItineraryIcon: React.FC<IconProps> = ({ size = 14, className = '', color = 'currentColor' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 512.064 512.064" 
    className={className}
    fill={color}
  >
    <path d="m92.131 246.868c-50.801 0-92.131 41.33-92.131 92.132 0 25.683 14.043 56.703 41.74 92.199 19.782 25.352 39.332 43.685 40.155 44.453l10.237 9.558 10.237-9.558c.823-.768 20.373-19.101 40.155-44.453 27.696-35.496 41.74-66.516 41.74-92.199-.001-50.802-41.331-92.132-92.133-92.132zm0 121.938c-16.435 0-29.806-13.371-29.806-29.806s13.371-29.806 29.806-29.806 29.806 13.371 29.806 29.806-13.371 29.806-29.806 29.806z" />
    <path d="m419.932 26.854c-50.801 0-92.131 41.33-92.131 92.131 0 25.683 14.043 56.703 41.739 92.199 19.781 25.352 39.332 43.685 40.154 44.453l10.237 9.558 10.236-9.558c.823-.768 20.374-19.101 40.155-44.453 27.697-35.496 41.74-66.516 41.74-92.199.002-50.8-41.328-92.131-92.13-92.131zm0 121.938c-16.435 0-29.806-13.371-29.806-29.806s13.371-29.806 29.806-29.806c16.436 0 29.807 13.371 29.807 29.806s-13.371 29.806-29.807 29.806z" />
    <path d="m364.929 479.688h-212.794v-30h212.794c22.058 0 40.003-17.945 40.003-40.003s-17.945-40.003-40.003-40.003h-83.896c-38.6 0-70.004-31.403-70.004-70.003s31.404-70.003 70.004-70.003h78.895v30h-78.895c-22.059 0-40.004 17.945-40.004 40.003s17.945 40.003 40.004 40.003h83.896c38.6 0 70.003 31.403 70.003 70.003s-31.403 70.003-70.003 70.003z" />
  </svg>
);

export const HotelItineraryIcon: React.FC<IconProps> = ({ size = 14, className = '', color = 'currentColor' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 512 512" 
    className={className}
    fill={color}
  >
    <path d="M445.437,31.625V0H213.914v31.786h-64.195v191.136c37.569,20.426,63.126,60.255,63.126,105.942
      c0,27.146-17.807,71.454-54.441,135.455c-2.912,5.088-5.817,10.072-8.685,14.927v28.848h165.23v-96.819h31.57v96.819h162.058
      V31.839L445.437,31.625z M283.377,377.329h-31.572v-31.57h31.572V377.329z M283.377,314.186h-31.572v-31.57h31.572V314.186z
      M283.377,252.494h-31.572v-31.57h31.572V252.494z M346.52,377.329h-31.572v-31.57h31.572V377.329z M346.52,314.186h-31.572
      v-31.57h31.572V314.186z M346.52,252.494h-31.572v-31.57h31.572V252.494z M378.091,178.828h-31.57v-36.834h-31.574v36.834h-31.57
      V73.59h31.57v36.834h31.574V73.59h31.57V178.828z M409.664,377.329h-31.572v-31.57h31.572V377.329z M409.664,314.186h-31.572
      v-31.57h31.572V314.186z M409.664,252.494h-31.572v-31.57h31.572V252.494z" />
    <path d="M92.35,239.937c-49.034,0-88.927,39.893-88.927,88.926c0,11.919,6.518,43.304,50.175,119.604
      C67.92,473.5,82.365,496.52,92.35,512c9.984-15.48,24.43-38.5,38.752-63.533c43.656-76.3,50.175-107.686,50.175-119.604
      C181.276,279.829,141.384,239.937,92.35,239.937z M92.35,387.482c-32.323,0-58.62-26.297-58.62-58.62s26.296-58.62,58.62-58.62
      c32.323,0,58.62,26.297,58.62,58.62S124.673,387.482,92.35,387.482z" />
    <path d="M92.35,301.813c-14.915,0-27.05,12.134-27.05,27.05c0,14.916,12.134,27.05,27.05,27.05c14.916,0,27.05-12.134,27.05-27.05
      C119.4,313.948,107.264,301.813,92.35,301.813z" />
  </svg>
);

export const BookIcon: React.FC<IconProps> = ({ size = 14, className = '', color = 'currentColor' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 512 512" 
    className={className}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="m406.713 15.5h-301.425c-58.056 0-105.288 47.232-105.288 105.288 0 58.337 47.723 105.288 104.66 105.288h47.29v-82.494c0-36.944 30.055-67 66.998-67h.146c36.865.079 66.856 30.135 66.856 67v82.494h120.763c58.056 0 105.287-47.232 105.287-105.288s-47.231-105.288-105.287-105.288zm29.794 90.606-60 60c-5.857 5.858-15.355 5.859-21.213 0l-30-30c-5.858-5.858-5.858-15.355 0-21.213 5.857-5.858 15.355-5.858 21.213 0l19.394 19.393 49.394-49.393c5.857-5.858 15.355-5.858 21.213 0 5.857 5.858 5.857 15.356-.001 21.213z" />
      <path d="m352.514 268.29-96.563-10.037v-114.672c0-20.404-16.517-36.956-36.921-37-20.465-.044-37.079 16.534-37.079 37v191.919h-.336l-36.523-30.5c-15.405-12.864-38.393-10.452-50.793 5.329-11.891 15.134-9.595 36.979 5.182 49.31l74.133 61.861h218.336v-108.556c0-22.702-16.909-41.848-39.436-44.654z" />
      <path d="m181.95 481.5c0 8.284 6.716 15 15 15h180c8.284 0 15-6.716 15-15v-30h-210z" />
    </g>
  </svg>
);


export const WalkIcon: React.FC<IconProps> = ({ size = 14, className = '', color = 'currentColor' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill={color}
  >
    <path d="m13 5.3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.7 3.3-2.6 13c-.1.6.3 1.2 1 1.2h.1c.5 0 .9-.3 1-.8l1.6-7.2 2.1 2v5c0 .5.4 1 1 1s1-.5 1-1v-5.6c0-.6-.2-1.1-.6-1.4l-1.5-1.4.6-3c1.1 1.2 2.6 2.1 4.4 2.4.6.1 1.1-.4 1.1-1 0-.5-.4-.9-.9-1-1.5-.3-2.8-1.1-3.4-2.3l-1-1.6c-.6-.9-1.7-1.3-2.7-.8l-3.8 1.4c-.7.4-1.2 1.1-1.2 1.9v2.4c0 .6.4 1 1 1s1-.4 1-1v-2.4z" />
  </svg>
);

export const CarIcon: React.FC<IconProps> = ({ size = 14, className = '', color = 'currentColor' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill={color}
  >
    <path d="M19 20H5V21C5 21.6 4.6 22 4 22H3C2.4 22 2 21.6 2 21V12L4.3 5.3C4.5 4.5 5.2 4 6 4H18C18.8 4 19.5 4.5 19.7 5.3L22 12V21C22 21.6 21.6 22 21 22H20C19.4 22 19 21.6 19 21V20ZM6.5 17C7.3 17 8 16.3 8 15.5C8 14.7 7.3 14 6.5 14C5.7 14 5 14.7 5 15.5C5 16.3 5.7 17 6.5 17ZM17.5 17C18.3 17 19 16.3 19 15.5C19 14.7 18.3 14 17.5 14C16.7 14 16 14.7 16 15.5C16 16.3 16.7 17 17.5 17ZM5 13H19V12H5V13Z" />
  </svg>
);

export const BikeIcon: React.FC<IconProps> = ({ size = 14, className = '', color = 'currentColor' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="5.5" cy="17.5" r="3.5"/>
    <circle cx="18.5" cy="17.5" r="3.5"/>
    <path d="M15 6a1 1 0 100-2 1 1 0 000 2zm-3 11.5V14l-3-3 4-3 2 3h2"/>
  </svg>
);

export const GiftIcon: React.FC<IconProps> = ({ size = 14, className = '', color = 'currentColor' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 12v10H4V12"></path>
    <path d="M2 7h20v5H2z"></path>
    <path d="M12 22V7"></path>
    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
  </svg>
);